"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingLibrary = void 0;
// tslint:disable-next-line:no-var-requires
require('dotenv').config();
const contentReports_1 = require("../reports/contents/contentReports");
const contentsByQuery_1 = require("../reports/contents/contentsByQuery");
const getContentBySearchText_1 = require("../reports/contents/getContentBySearchText");
const getContentIdsFromCustomProperties_1 = require("../reports/contents/getContentIdsFromCustomProperties");
const getContentIdsFromGroupIds_1 = require("../reports/contents/getContentIdsFromGroupIds");
const getContentsByIds_1 = require("../reports/contents/getContentsByIds");
const contentVersionLogReports_1 = require("../reports/contentVersionLogs/contentVersionLogReports");
const getContentVersionLogBySearchText_1 = require("../reports/contentVersionLogs/getContentVersionLogBySearchText");
const getContentVersionLogsByIds_1 = require("../reports/contentVersionLogs/getContentVersionLogsByIds");
const versionLogsByQuery_1 = require("../reports/contentVersionLogs/versionLogsByQuery");
const getDashboardsByFilters_1 = require("../reports/dashboards/getDashboardsByFilters");
const getDashboardsBySearchText_1 = require("../reports/dashboards/getDashboardsBySearchText");
const getGroupsByIds_1 = require("../reports/groups/getGroupsByIds");
const getGroupsBySearchText_1 = require("../reports/groups/getGroupsBySearchText");
const groupReports_1 = require("../reports/groups/groupReports");
const getUserAggregratedByRegisterType_1 = require("../reports/iltAdminPage/getUserAggregratedByRegisterType");
const liveClassReports_1 = require("../reports/liveClass/liveClassReports");
const getLiveClassByIds_1 = require("../reports/lyearnLive/getLiveClassByIds");
const stateInterationReports_1 = require("../reports/stateInterationReports");
const userContentReports_1 = require("../reports/userContentReports");
const getStateById_1 = require("../reports/userContentReports/__common/getStateById");
const getUserContentByQuery_1 = require("../reports/userContentReports/getUserContentByQuery");
const getUserByQuery_1 = require("../reports/users/getUserByQuery");
const getUserIdsAndUniqueIdsFromCustomProperties_1 = require("../reports/users/getUserIdsAndUniqueIdsFromCustomProperties");
const getUserIdsAndUniqueIdsFromGroupIds_1 = require("../reports/users/getUserIdsAndUniqueIdsFromGroupIds");
const getUsersByIds_1 = require("../reports/users/getUsersByIds");
const getUsersBySearchText_1 = require("../reports/users/getUsersBySearchText");
const userReports_1 = require("../reports/users/userReports");
const usersByQuery_1 = require("../reports/users/usersByQuery");
const getUsersByIdsWithProjection_1 = require("../reports/users/usersByQuery/getUsersByIdsWithProjection");
class ReportingLibrary {
    constructor() {
        this.cache = {};
    }
    // User Content End Points
    getUserContentReports(input) {
        return userContentReports_1.getUserContentReports(this, input);
    }
    getUserContentByQuery(input) {
        return getUserContentByQuery_1.getUserContentByQuery(this, input);
    }
    // User End Points
    getUserReports(input) {
        return userReports_1.getUserReports(this, input);
    }
    getUsersByIds(filter, withManager = false) {
        return getUsersByIds_1.getUsersByIds(this, filter, withManager);
    }
    getUserByQuery(query) {
        return getUserByQuery_1.getUserByQuery(query);
    }
    getUsersByQuery(query) {
        return usersByQuery_1.getUsersByQuery(query);
    }
    getUserBySearchText(input) {
        return getUsersBySearchText_1.getUserBySearchText(input);
    }
    getUsersByIdsWithProjection(input) {
        return getUsersByIdsWithProjection_1.getUsersByIdsWithProjection(input);
    }
    getUserIdsAndUniqueIdsFromGroupIds(filters) {
        return getUserIdsAndUniqueIdsFromGroupIds_1.getUserIdsAndUniqueIdsFromGroupIds(filters);
    }
    getUserIdsAndUniqueIdsFromCustomProperties(filters) {
        return getUserIdsAndUniqueIdsFromCustomProperties_1.getUserIdsAndUniqueIdsFromCustomProperties(filters);
    }
    // Content End Points
    getContentReports(input, searchMatchConfig) {
        return contentReports_1.getContentReports(this, input, searchMatchConfig);
    }
    getContentsByIds(filters, withRootContent = false, attachContentVersionLog = false) {
        return getContentsByIds_1.getContentsByIds(this, filters, withRootContent, attachContentVersionLog);
    }
    getContentsByQuery(query) {
        return contentsByQuery_1.getContentsByQuery(query);
    }
    getContentBySearchText(input) {
        return getContentBySearchText_1.getContentBySearchText(this, input);
    }
    getContentIdsFromGroupIds(filters) {
        return getContentIdsFromGroupIds_1.getContentIdsFromGroupIds(filters);
    }
    getContentIdsFromCustomProperties(filters) {
        return getContentIdsFromCustomProperties_1.getContentIdsFromCustomProperties(filters);
    }
    // ContentVersionLogs endpoint
    getContentVersionLogsByIds(filter) {
        return getContentVersionLogsByIds_1.getContentVersionLogsByIds(this, filter);
    }
    getContentVersionLogsByQuery(query) {
        return versionLogsByQuery_1.getContentVersionLogsByQuery(query);
    }
    getContentVersionLogBySearchText(input) {
        return getContentVersionLogBySearchText_1.getContentVersionLogBySearchText(this, input);
    }
    getContentVersionLogReports(input) {
        return contentVersionLogReports_1.getContentVersionLogReports(this, input);
    }
    // liveClass endpoint
    getLiveClassReports(input) {
        return liveClassReports_1.getLiveClassReports(this, input);
    }
    // lyearn-live  endpoint
    getLiveClassById(filters) {
        return getLiveClassByIds_1.getLiveClassByIds(filters);
    }
    // StateInteractions endpoint
    getStateInteractionReports(input) {
        return stateInterationReports_1.getStateInteractionReports(this, input);
    }
    // State endpoints
    getStatesByIds(stateIds) {
        return getStateById_1.getStatesByIds(this, stateIds);
    }
    // Reporting Dashboard endpoints
    getDashboards(input) {
        return getDashboardsByFilters_1.getDashboards(this, input);
    }
    getDashboardsBySearchText(input) {
        return getDashboardsBySearchText_1.getDashboardsBySearchText(this, input);
    }
    // Group endpoints
    getGroupReports(input) {
        return groupReports_1.getGroupReports(this, input);
    }
    getGroupsBySearchText(input) {
        return getGroupsBySearchText_1.getGroupsBySearchText(input);
    }
    getGroupsByIds(filters) {
        return getGroupsByIds_1.getGroupsByIds(this, filters);
    }
    // ILT Admin Page Session Tabs
    getUserAggregratedByRegisterType(input) {
        return getUserAggregratedByRegisterType_1.getUserAggregratedByRegisterType(input);
    }
}
exports.ReportingLibrary = ReportingLibrary;
//# sourceMappingURL=index.js.map